import React from 'react';
import PropTypes from 'prop-types';
import pallet from 'constants/colors';

const styles = {
  container: {

  },
  subtitle: {
    marginLeft: 12,
    lineHeight: 2,
  },
};

const KTitle = ({
  title,
  style,
  containerStyle,
  subtitle,
  subtitleStyle,
  dataCy,
}) => (
  <div style={{ ...styles.container, ...containerStyle }} data-cy={dataCy}>
    <h2 style={{ color: pallet.titleColor, ...style }}>{title}</h2>
    {subtitle && <span style={{ ...styles.subtitle, ...subtitleStyle }}>{subtitle}</span>}
  </div>
);

KTitle.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  style: PropTypes.object,
  containerStyle: PropTypes.object,
  subtitleStyle: PropTypes.object,
  dataCy: PropTypes.string,
};

export default KTitle;



// WEBPACK FOOTER //
// ./src/components/KJRN/KTitle.js